import React from "react";
import { array } from "prop-types";

import "./footer-menu.m.css";

const FooterMenu = ({ menu = [] }) => {
  return (
    <div styleName="wrapper" id="footer-menu">
      {menu.map((item, index) => (
        <a href={item.completeUrl} key={index} styleName="menu-link" target="_blank" rel="noopener noreferrer">
          {item.title}
        </a>
      ))}
    </div>
  );
};

FooterMenu.propTypes = {
  menu: array
};

export default FooterMenu;
